export default "__VITE_PUBLIC_ASSET__3e846803__"